import { marked } from 'marked';
import TurndownService from 'turndown';

// Convertit du markdown en HTML
export async function markdownToHtml(markdown) {
  let clean = markdown || '';
  // Supprimer les balises ```markdown ... ``` si présentes
  if (clean.startsWith('```markdown')) {
    clean = clean.replace(/^```markdown\s*/, '').replace(/```$/, '');
  }
  return marked.parse(clean);
}

// Convertit du HTML en markdown
export async function htmlToMarkdown(html) {
  const turndownService = new TurndownService();
  return turndownService.turndown(html || '');
} 